import appService from 'services/common';

const getFaqAPI = (params?: object) => {
  return appService.get('/faq', { params });
};
const getFaqTagAPI = (params?: object) => {
  return appService.get('/faq/tags', { params });
};
export { getFaqAPI, getFaqTagAPI };
